/**
 * Provenance tags the logging forms may attach to a manual meal entry. The
 * server accepts exactly these from HTTP clients.
 */
export const MANUAL_MEAL_ENTRY_SOURCES = ['manual', 'saved_meal', 'user_product', 'off'] as const;

export type ManualMealEntrySource = (typeof MANUAL_MEAL_ENTRY_SOURCES)[number];
